<template>
<div class="modal fade" id="modalChangeTimezone" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Alteração de Fuso.</h4>
      </div>

      <div class="modal-body">
        <!-- Loading -->
        <div v-if="loadingModal" class="loading center_vertical">
          <div class="loader-mini-box">
            <div class="spinner-box">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
        </div>

        <form v-if="!loadingModal">
          <div class="form-group owner-select">
            <label>Responsável</label>
            <select v-model="timeZone" id="owner" name="owner" required>
              <option value="">Selecione</option>
              <option v-for="(tz, index) in listTimezone" v-bind:value="index">{{tz}}</option>
            </select>
            <span v-if="errorMsg.timeZone" class="error-msg">{{errorMsg.toWho}}</span>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button v-if="!loadingModal" v-on:click="changeTimezone()" :disabled="loadingChangeModal" v-bind:class="{'disable': loadingChangeModal}" type="submit" class="btn btn-register">
          <span v-if="!loadingChangeModal">Salvar</span>
          <div class="loading-btn" v-else>
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
        </button>
        <button v-on:click="closeModal()" class="close-btn">Fechar</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  GET_TIMEZONE,
  ATT_TIMEZONE
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../utils";
import swal from "sweetalert";

export default {
  name: "modalChangeTimezone",
  props: ['dataCompanyModal'],
  data() {
    return {
      loadingModal: false,
      modalContext: '',
      companyValue: '',
      listTimezone: [],
      timeZone: '',
      errorMsg: {
        timeZone: ''
      },
      loadingChangeModal: false
    }
  },
  watch: {
    dataCompanyModal: function (val) {
      this.companyValue = val;
      this.modalContext = val.context;

      this.getListTimeZone();
    },
  },
  methods: {
    getListTimeZone() {
      this.loadingModal = true;
      REQUEST_SERVICE.get(GET_TIMEZONE).then((response) => {
        UTIL_SERVICE.console("RESULT GET_TIMEZONE:", response.data);

        this.listTimezone = response.data;
        this.loadingModal = false;
      }).catch((reason) => {
        this.loadingModal = false;
      });
    },
    closeModal() {
      $('#modalChangeTimezone').modal('toggle');
    },
    changeTimezone() {
      this.errorMsg.timeZone = "";
      if (!this.loadingChangeModal && this.timeZone) {

        this.loadingChangeModal = true;
        UTIL_SERVICE.console("DATA SEND:", this.timeZone);
        REQUEST_SERVICE.requestContext('PUT', ATT_TIMEZONE, this.modalContext, {
          timeZone: this.timeZone.charAt(0).toUpperCase() + this.timeZone.slice(1),
          companyId: this.$route.params.idCompany
        }).then((response) => {
          UTIL_SERVICE.console("RESULT ATT_TIMEZONE:", response);
          this.loadingChangeModal = false;

          $('#modalChangeTimezone').modal('toggle');

          swal("Aviso", "Empresa atualizada com sucesso.", "success");
        }).catch((reason) => {
          this.loadingChangeModal = false;
          $('#modalChangeTimezone').modal('toggle');

          swal("Aviso", "Entre em contato com a equipe de DEV.", "error");
        });
      } else {
        this.errorMsg.timeZone = "Preencha um email válido.";
      }
    }
  }
}
</script>

<style lang="scss">
#modalChangeTimezone {
  .owner-select {
    width: 100%;

    select {
      border: 1px solid #999;
      border-radius: 5px;
      height: 34px;
      width: 100%;
      padding: 0 10px;
      cursor: pointer;
    }
  }

  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalChangeTimezone.vue